import { base } from "../constants";
import PageRouterList from "../routes/routeList";

export const buildPatientFeedbackLink = (
  clinicId: number,
  patientId: number,
) => {
  const feedbackPath = PageRouterList.patientFeedback
    .replace(":clinicId", String(clinicId))
    .replace(":patientId", String(patientId));

  return `${window.location.origin}${base}${feedbackPath}`;
};
